export default __webpack_public_path__ + "static/media/gallerybg.cf005b8f.jpg";